const description = value => value;

export default description;
